import { render } from "./opDate.vue?vue&type=template&id=48b4d5a7&ts=true"
import script from "./opDate.vue?vue&type=script&lang=ts"
export * from "./opDate.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__